import { useNavigate, Link } from "react-router-dom";
import { BsArrowLeft } from "react-icons/bs";
import { FaWrench, FaSyncAlt, FaShieldAlt } from "react-icons/fa";

export default function AutoServiceCenter() {
  const navigate = useNavigate();

  return (
    <main className="bg-[#F3F3F3] text-[#0B132A] min-h-screen">
      <div className="w-full bg-white/70 backdrop-blur border-b border-gray-200">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 md:px-10 xl:px-20 h-14 flex items-center gap-4">
          <button
            onClick={() => navigate(-1)}
            className="inline-flex items-center gap-2 px-3 py-1.5 rounded-md bg-gray-100 hover:bg-gray-200 text-sm transition-colors"
            aria-label="Kembali"
          >
            <BsArrowLeft size={16} />
            Kembali
          </button>
          <span className="text-gray-400">/</span>
          <span className="text-sm text-gray-600">Services</span>
          <span className="text-gray-400">/</span>
          <span className="text-sm font-medium">Service Center</span>
        </div>
      </div>

      <section className="py-10 md:py-16 text-center">
        <div className="max-w-3xl mx-auto px-4">
          <h1
            className="text-2xl md:text-4xl font-semibold leading-tight"
            data-aos="fade-up"
          >
            Service Center
          </h1>
          <p
            className="mt-4 text-gray-600 leading-relaxed"
            data-aos="fade-up"
            data-aos-delay="100"
          >
           Layanan instalasi kami memastikan setiap perangkat audiovisual 
           dipasang dengan standar industri terbaik, menghasilkan sistem yang 
           rapi, aman, dan langsung siap mendukung kebutuhan operasional Anda. 
          </p>

          <div
            className="mt-6 flex justify-center gap-3"
            data-aos="fade-up"
            data-aos-delay="200"
          >
            <Link
              to="/request"
              className="inline-flex items-center gap-2 rounded-full border border-emerald-600 px-5 py-2.5 text-sm font-medium text-emerald-700 hover:text-white hover:bg-emerald-600 transition-colors"
            >
              Ajukan Service
              <svg width="16" height="16" viewBox="0 0 24 24" fill="none"
                stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                <path d="M5 12h14" /><path d="m12 5 7 7-7 7" />
              </svg>
            </Link>
            <a
              href="https://wa.me/6289507085550"
              target="_blank"
              rel="noopener noreferrer"
              className="inline-flex items-center gap-2 rounded-full bg-white px-5 py-2.5 text-sm font-medium text-gray-700 border border-gray-300 hover:bg-gray-100 transition-colors"
            >
              Chat WhatsApp
            </a>
          </div>
        </div>
      </section>

      <section className="py-0">
        <div className="max-w-5xl mx-auto px-4 grid sm:grid-cols-2 lg:grid-cols-3 gap-6">
          {[
            {
              icon: <FaWrench className="text-emerald-600 text-2xl" />,
              title: "Perbaikan Cepat",
              desc: "Diagnosa akurat dan solusi langsung dari teknisi ahli",
            },
            {
              icon: <FaSyncAlt className="text-emerald-600 text-2xl" />,
              title: "Maintenance",
              desc: "Menjaga perangkat tetap stabil, meminimalisir risiko kerusakan, dan memperpanjang usia penggunaan.",
            },
            {
              icon: <FaShieldAlt className="text-emerald-600 text-2xl" />,
              title: "Garansi & Keamanan",
              desc: "Layanan resmi dengan standar jelas serta jaminan kualitas yang dapat dipercaya.",
            },
          ].map((s, i) => (
            <div
              key={i}
              className="bg-white rounded-xl shadow hover:shadow-md transition p-6 text-center flex flex-col items-center gap-3"
              data-aos="fade-up"
              data-aos-delay={i * 120}
            >
              <div className="w-12 h-12 flex items-center justify-center rounded-full bg-emerald-100">
                {s.icon}
              </div>
              <h3 className="text-lg font-semibold">{s.title}</h3>
              <p className="text-sm text-gray-600">{s.desc}</p>
            </div>
          ))}
        </div>
      </section>

      <section className="pt-16 pb-16">
        <div className="max-w-5xl mx-auto px-4">
          <img
            src="/images/services/avd4.png"
            alt="Auto Service Center"
            className="w-full rounded-xl shadow-md object-cover"
            loading="lazy"
          />
        </div>
      </section>
    </main>
  );
}
